import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { EnvironmentService } from 'src/app/services/environment.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-error-page-base',
  templateUrl: './error-page-base.component.html',
  styleUrls: ['./error-page-base.component.scss'],
})
export class ErrorPageBaseComponent implements OnInit {
  isUserLoggedIn: boolean;
  originUrl: any;

  constructor(private environmentService: EnvironmentService, private router: Router, private userService: UserService) {}

  ngOnInit(): void {
    this.isUserLoggedIn = !!this.userService.getUserStatus();
  }

  openImprint(): void {
    const impressumRoute = this.environmentService.impressumRoute ?? '/impressum';

    if (this.isValidUrl(impressumRoute)) {
      window.open(impressumRoute);
      return;
    }

    this.router.navigate([impressumRoute]);
  }

  private isValidUrl(value: string) {
    let url: URL;

    try {
      url = new URL(value);
    } catch (_) {
      return false;
    }

    return url.protocol === 'http:' || url.protocol === 'https:';
  }
}
